// Colby College's majors (#2739). Read on 2026-10-01 from Colby's official
// Majors and Minors list (colby.edu/academics/majors-and-minors, filtered to
// majors). Colby awards the bachelor of arts. The list's eleven entries written
// with a colon ("Biology: Neuroscience", "Economics: Financial Markets" and so
// on) are concentrations within a major, as the Course Catalogue's department
// requirements describe them (Biology, Chemistry and Physics checked), so they
// are left out; the 48 majors left match the "48 majors" on Colby's College
// Profile. Minors and the independent major option are left out.
const majors = {
    "slug": "colby-college",
    "read": "2026-10-01",
    "intro": "Every major on Colby's official Majors and Minors list, each leading to the bachelor of arts. Concentrations within a major, minors and the independent major are left out.",
    "groups": [
        {
            "name": "Majors, A to Z",
            "source": {
                "label": "Colby College, Majors and Minors",
                "url": "https://www.colby.edu/academics/majors-and-minors/"
            },
            "majors": [
                {
                    "name": "African-American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry-Biochemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Civilization",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Civilization-Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Civilization-English",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Classics-English",
                    "degree": "B.A."
                },
                {
                    "name": "Computational Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Computational Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Data Science",
                    "degree": "B.A."
                },
                {
                    "name": "East Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Educational Studies",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Computation",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.A."
                },
                {
                    "name": "French Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.A."
                },
                {
                    "name": "German Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Government",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Jewish Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music-Interdisciplinary Computation",
                    "degree": "B.A."
                },
                {
                    "name": "Performance Theater and Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Russian Language and Culture",
                    "degree": "B.A."
                },
                {
                    "name": "Science, Technology, and Society",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Theater and Dance-Interdisciplinary Computation",
                    "degree": "B.A."
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
